import SubGroup from 'leaflet.featuregroup.subgroup/dist/leaflet.featuregroup.subgroup-src.js'
export default SubGroup
